export enum ImageType {
	thumbnail = "thumbnail",
	detail = "detail",
	fullscreen = "fullscreen",
}
